import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, of, Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState , BaseModel, PaginatorState, SortState, GroupingState } from '../../_metronic/shared/crud-table';
import { Policy } from '../_models/policy.model';
import { Ramo, SubRamo, Mes, Anyo, Endoso } from '../_models/general.model';
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { catchError, finalize, tap } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';

const DEFAULT_STATE: ITableState = {
  filter: {},
  paginator: new PaginatorState(),
  sorting: new SortState(),
  searchTerm: '',
  grouping: new GroupingState(),
  entityId: undefined,
  paramsGet: "",
  paramsPost: {}
};

@Injectable({
  providedIn: 'root'
})


export class DocRequestService extends TableService<any> implements OnDestroy {

	API_URL = `${environment.url}/${environment.apiUrl}/Generico/get_documentos_solicitud_corta?`;
	constructor(@Inject(HttpClient) http, private auth: AuthService) {
	  super(http);
	}
  
	find(tableState: ITableState): Observable<TableResponseModel<any>> {
	  return this.http.get<any[]>(this.API_URL + tableState.paramsGet, {headers: this.auth.httpHeaders}).pipe(
		map((response: any[]) => {
		  const filteredResult = baseFilter(response, tableState);
		  const result: TableResponseModel<any> = {
			items: filteredResult.items,
			total: filteredResult.total
		  };
		  return result;
		})
	  );
	}

	
  
	ngOnDestroy() {
	  this.subscriptions.forEach(sb => sb.unsubscribe());
	}
  }